import { useNavigate } from "react-router-dom";

const UserAccountCommunityNavigation = (userid) => {
  const navigate = useNavigate();
  
  const goToUserAccountCommunity = () => {
    navigate(`/community-page/${userid}/home`)
  };

  return { goToUserAccountCommunity }; // ✅ Return an object
};

export default UserAccountCommunityNavigation;